"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchUserHoldingViewMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class SwitchUserHoldingViewMapper {
    toDomain(result) {
        const id = lodash_1.default.get(result, "data.switchHoldingView.id");
        return {
            id,
        };
    }
}
exports.SwitchUserHoldingViewMapper = SwitchUserHoldingViewMapper;
